import * as React from 'react';
import classNames from 'classnames';
import formStyle from '../style/WForm.less';
import { getKomplexRowClassname } from '../../../main/functions/getFormKey';

interface WFormFieldTextProps extends React.ClassAttributes<any> {
    id?: string;
    label: JSX.Element;
    name: string;
    value: string;
    row?: any;
    hidden_input?: boolean;
    required?: boolean;
    readonly?: boolean;
    showMode?: boolean;
    disabled?: boolean;
    isTextarea?: boolean;
    inComplexForm?: boolean;
    maxLength?: number;
    placeholder?: string;
    layout?: string;
    customStyle?: any;
    errorLevelKey?: string;
    onValueChange?(name: string, value: any): void;
}

export class WFormFieldText extends React.Component<WFormFieldTextProps, {}> {

    constructor(props: any) {
        super(props);
        this.onInputChange = this.onInputChange.bind(this);
    }

    onInputChange(event: any) {
        if (this.props.onValueChange) {
            this.props.onValueChange(this.props.name, event.target.value);
        }
    }

    render() {
        const { layout, customStyle, maxLength, placeholder, id, showMode, hidden_input, errorLevelKey } = this.props;
        const disabled: boolean = this.props.readonly || this.props.disabled ? true : false;
        const styleDisabled: any = disabled ? { backgroundColor: 'var(--color-wform-field-bg-disabled)' } : {};
        if (hidden_input) {
            styleDisabled.display = 'none';
        }
        const complexLayout = (layout === 'sidebysideComplex' || layout === 'sidebysideComplexGreen') ? true : false;
        const customStyleInput = customStyle && customStyle.classInput ? customStyle.classInput : {};
        const customStyleTextarea = customStyle && customStyle.styleTextarea ? customStyle.styleTextarea : {};
        const errInputStyle = typeof errorLevelKey === 'string' && errorLevelKey === 'error' ? formStyle.errorlevel_default : null;
        const krCls = getKomplexRowClassname((this.props.row || {})._formKey, this.props.name) || undefined;

        if (showMode) {
            return (
                <div className={classNames(formStyle.fieldBox, krCls)}
                    style={{ ...(this.props.isTextarea && complexLayout ? { height: 65 } : {}) }}
                >
                    {this.props.label}
                    <div
                        className={classNames(formStyle.input, formStyle.showMode, errInputStyle)}
                        style={{ overflow: 'hidden' }}
                    >
                        {hidden_input ? '' : (this.props.value || placeholder || '')}
                    </div>
                </div>
            );
        }

        return (
            <div className={classNames(formStyle.fieldBox, krCls)}
                style={{ ...(this.props.isTextarea && complexLayout ? { height: 65 } : {}) }}
            >
                {this.props.label}
                <div className={formStyle.input} style={customStyleInput}>
                    {this.props.isTextarea ?
                        <textarea
                            id={id}
                            style={{ ...styleDisabled, ...customStyleTextarea }}
                            className={classNames(formStyle.inputText, errInputStyle)}
                            name={this.props.name}
                            value={this.props.value ? this.props.value : ''}
                            readOnly={disabled}
                            onChange={this.onInputChange}
                            placeholder={placeholder}
                            autoComplete='off'
                        />
                        :
                        <div className={formStyle.flowWidth100}>
                            <input
                                id={id}
                                style={{ ...styleDisabled }}
                                type='text'
                                className={classNames(formStyle.inputText, errInputStyle)}
                                name={this.props.name}
                                value={this.props.value ? this.props.value : ''}
                                readOnly={disabled}
                                onChange={this.onInputChange}
                                maxLength={maxLength > 0 ? maxLength : 999}
                                placeholder={placeholder}
                                autoComplete='off'
                            />
                            <br />
                            {!this.props.inComplexForm && <span style={{ fontStyle: 'italic' }}>
                                {maxLength > 0 ? (' max. ' + maxLength + ' Zeichen') : ''}
                            </span>}
                        </div>
                    }
                </div>
            </div>
        );
    }
}
